import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import request from "../../../../../../../../Services/API/Requests";
import {multiLanguageValue} from "../../../../../../../JsonScreen/Utils/lib";
import DefaultType from "../../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import TypeEntity from "../../../../../../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";
import {useSelector} from "react-redux";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 550,
        overflow: 'auto',
    }
}))

const CreateFromTemplate = ({selectedTemplate}) => {
    const userLanguage = useSelector(state => state.app.userLanguage);
    const classes = useStyles();
    const [currentTemplate, setCurrentTemplate] = useState();

    useEffect(() => {
        if(!selectedTemplate) {
            setCurrentTemplate(undefined)
        }
        getTemplate(selectedTemplate).then(res => {
            setCurrentTemplate(res)
        }).catch(e => {
            console.log(e)
        })
    }, [selectedTemplate]);

    async function getTemplate(id) {
        return await request({
            url: "/screen/read",
            data: {id: id}
        })
    }

    function onChangeFields(v, p) {

    }

    return (
        <div className={classes.container}>
            <div style={{padding: "15px 30px"}}>
                <Typography variant={"h5"}>{currentTemplate ? multiLanguageValue(currentTemplate?.name, userLanguage) : "Empty Template"}</Typography>
            </div>
            <div style={{width: '100%', display: 'flex', justifyContent: 'center', padding: "15px 30px"}}>
                <div style={{padding: 15, background: "#d5d5d5", width: '100%'}}>
                    {!currentTemplate ? (
                        <div style={{width: '100%',
                            height: 300}}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',

                            }}>
                                <div style={{
                                    width: '30%',
                                    height: 50,
                                    border: '1px solid',
                                    borderRadius: 5,
                                    borderColor: '#a8a8a8'
                                }}>
                                </div>
                                <div style={{
                                    width: '30%',
                                    height: 50,
                                    border: '1px solid',
                                    borderRadius: 5,
                                    borderColor: '#a8a8a8'
                                }}>
                                </div>
                                <div style={{
                                    width: '30%',
                                    height: 50,
                                    border: '1px solid',
                                    borderRadius: 5,
                                    borderColor: '#a8a8a8'
                                }}>
                                </div>
                            </div>
                            <div style={{
                                marginTop: 10,
                                width: '100%',
                                height: 160,
                                border: '1px solid',
                                borderRadius: 10,
                                borderColor: '#a8a8a8'
                            }}>
                            </div>

                        </div>
                    ) : (<div
                        style={{
                            width: '100%',
                            height: 300,
                            backgroundPosition: 'center center',
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundImage: `url(${currentTemplate?.thumbnail})`
                        }}
                    />)}
                </div>
            </div>

            <div style={{padding: "15px 30px"}}>
                <DefaultType
                    field={{
                        type: "string",
                        label: "Screen Name",
                        path: "name",
                    }}
                    fieldStyles={{
                        presentation: "standard",
                        withoutStyles: true,
                        fullWidth: true,
                        width: 250,
                    }}
                    values={{}}
                    setValue={onChangeFields}
                />
                <DefaultType
                    field={{
                        type: "string",
                        label: "Description",
                        path: "description"
                    }}
                    fieldStyles={{
                        presentation: "standard",
                        withoutStyles: true,
                        fullWidth: true,
                        width: 250,
                    }}
                    values={{}}
                    setValue={onChangeFields}
                />
                <TypeEntity
                    setValue={onChangeFields}
                    fieldStyles={{
                        presentation: "standard",
                        withoutStyles: true,
                        width: 250,
                        fullWidth: false
                    }}
                    values={{}}
                    field={{
                        label: "Application",
                        path: 'application',
                        entity: "application",
                        type: "entityExternal",
                        optLabel: "name",
                        autofocus: false,
                        required: false,
                        isArray: true,
                    }}
                />
                <TypeEntity
                    setValue={onChangeFields}
                    fieldStyles={{
                        presentation: "standard",
                        withoutStyles: true,
                        width: 250,
                        fullWidth: false
                    }}
                    values={{}}
                    field={{
                        label: "Tag",
                        path: 'tag',
                        entity: "systemTag",
                        type: "entityExternal",
                        autofocus: false,
                        required: false,
                        isArray: true
                    }}
                />
            </div>
        </div>
    )
}

export default CreateFromTemplate;